export class LanguagesTwoDigit {  
  static HU: string = "hu";
  static CS: string = "cs";
  static DE: string = "de";
  static EN: string = "en";
  static UK: string = "uk";
  static HR: string = "hr";
  static PL: string = "pl";
  static RO: string = "ro";
  static RU: string = "ru";
  static SK: string = "sk";  
}

export class LanguagesFiveDigit {  
  static HU: string = "hu-HU";
  static CS: string = "cs-CZ";
  static DE: string = "de-DE";
  static EN: string = "en-GB";
  static UK: string = "uk-UA";
  static HR: string = "hr-HR";
  static PL: string = "pl-PL";
  static RO: string = "ro-RO";
  static RU: string = "ru-RU";
  static SK: string = "sk-SK";  
}

export class LanguageItem {
  constructor(
    public twoDigit: string,
    public fiveDigit: string
  ) { }
}

export class LanguageConsts {
  static HU: LanguageItem = new LanguageItem(LanguagesTwoDigit.HU, LanguagesFiveDigit.HU);
  static CS: LanguageItem = new LanguageItem(LanguagesTwoDigit.CS, LanguagesFiveDigit.CS);
  static DE: LanguageItem = new LanguageItem(LanguagesTwoDigit.DE, LanguagesFiveDigit.DE);
  static EN: LanguageItem = new LanguageItem(LanguagesTwoDigit.EN, LanguagesFiveDigit.EN);
  static UK: LanguageItem = new LanguageItem(LanguagesTwoDigit.UK, LanguagesFiveDigit.UK);
  static HR: LanguageItem = new LanguageItem(LanguagesTwoDigit.HR, LanguagesFiveDigit.HR);
  static PL: LanguageItem = new LanguageItem(LanguagesTwoDigit.PL, LanguagesFiveDigit.PL);
  static RO: LanguageItem = new LanguageItem(LanguagesTwoDigit.RO, LanguagesFiveDigit.RO);
  static RU: LanguageItem = new LanguageItem(LanguagesTwoDigit.RU, LanguagesFiveDigit.RU);
  static SK: LanguageItem = new LanguageItem(LanguagesTwoDigit.SK, LanguagesFiveDigit.SK);
}
